/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {AnyAction, CollectionFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient, ComplianceDirectorView} from '@modifi/onboarding-api-clients'
import {createSelector} from 'reselect'

const apiClient = getAuthenticatedThemisClient()

type EntityWithId = ComplianceDirectorView & {
  externalId: NonNullable<ComplianceDirectorView['externalId']>
}

const {reducer, selectors, actions} = CollectionFactory<
  Record<string, any>,
  EntityWithId,
  any,
  Record<string, never>
>({
  entityPrimaryKeySelector: entity => entity.externalId!,
  reducerPath: ['data', 'directors'],
  actionNamePrefix: `data/directors`,
  fetchRequest: () =>
    apiClient.Directors.fetch().then(res => (res.data()?.directors as EntityWithId[]) || []),
})

export default reducer as Reducer

export const selectDirectors = (state: Record<string, any>): EntityWithId[] =>
  selectors.selectByKeyWindow(state, 'all') as EntityWithId[]

export const selectDirectorsWhereLoaded = (state: Record<string, any>): boolean =>
  selectors.selectFetchCountByKeyWindow(state, 'all') > 0

export const selectDirectorsAreLoading = (state: Record<string, any>): boolean =>
  selectors.selectIsKeyWindowLoading(state, 'all')

export const selectDirectorByExternalId = (
  state: Record<string, any>,
  externalPersonId: string
): ComplianceDirectorView | null =>
  selectors.selectById(state, externalPersonId) as ComplianceDirectorView | null

export const selectDirectorNameByExternalId = createSelector(selectDirectorByExternalId, director =>
  director ? `${director?.firstName || ''} ${director?.lastName || ''}` : ''
)

export const aFetchDirectors = (): any => actions!.fetch('all')

export const aUpdateLocalDirector = (Director: EntityWithId, merge = true): AnyAction =>
  actions!.update(Director, merge) as unknown as AnyAction

export const aAppendDirectorToCompany = (entity: EntityWithId): AnyAction =>
  actions!.appendEntity?.('all', {ident: entity.externalId, entity}) as AnyAction

export const aDeleteLocalDirector = (externalPersonId: string): AnyAction =>
  actions!.deleteEntity?.('all', externalPersonId) as AnyAction
